import { headerStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsHeader";
import { css } from "styled-components";

Object.assign(headerStyles, {
    ...headerStyles,
    lastUpdateText: {
        css: css`
            padding-right: 30px;
            + button {
                top: 1px;
            }
        `,
    },
    sharingStatus: {
        statusText: {
            css: css`
                padding-right: 30px;
                line-height: 22px;
                position: relative;
                top: -1px;
                > div {
                    padding-left: 5px;
                }
            `,
        },
        privateTooltip: {
            cssOverrides: {
                tooltipContainer: css`
                    left: 50px;
                    &:after {
                        left: 35%;
                    }
                `,
            },
        },
    },
    totalText: {
        weight: "bold",
        css: css`
            padding-right: 30px;
        `,
    },
});
